import { SET_UNSAVED_CHANGES, SET_WINDOW_DIMENSIONS } from '../types/types';

export const SetUnsavedChangesAction = (payload: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_UNSAVED_CHANGES,
			payload: payload
		});
	};
};

export const setWindowDimensionsAction = (payload: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_WINDOW_DIMENSIONS,
			payload: payload
		});
	};
};
